<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="460px"
    :before-close="handleClose"
    class="shareDialog"
    :close-on-click-modal="false"
    destroy-on-close
  >
    <div v-if="shareInfo">
      <div class="printer">
        <Printer :item="printer" />
        <div class="printInfo">
          <p class="printName">
            {{ printer.equipmentAlias || printer.equipmentName }}
          </p>
          <p class="printDes">{{ getOptions(printer) }}</p>
        </div>
      </div>
      <div class="content" v-show="mode === 'default'">
        <p class="title">分享链接</p>
        <div class="shareBox">
          <div class="shareInfo">
            <p v-if="shareInfo && shareInfo.invalidTime">
              链接：{{ shareInfo && shareInfo.invalidTime }} 前有效
            </p>
            <p v-if="shareInfo && !shareInfo.invalidTime">链接：永久有效</p>
            <p>{{ shareInfo && shareInfo.shareLinks }}</p>
          </div>
          <div class="copyBtn" @click="copyUrl">复制链接</div>
        </div>
        <div class="otherWay">
          <span>其他分享方式</span>
          <img
            @click="toggleMode('wechat')"
            src="~@/assets/img/share/wechat.png"
            alt=""
          />
          <img
            @click="toggleMode('qrcode')"
            src="~@/assets/img/share/qrcode.png"
            alt=""
          />
        </div>
      </div>
      <div class="imgUrlBox" v-show="mode === 'wechat'">
        <div class="imgUrl">
          <img
            id="wechatImg"
            :src="
              `https://dyapi.foxitcloud.cn/printEquipmentShare/getShareWxACode/${shareInfo &&
                shareInfo.shareCode}?appKey=${appkey}${
                accessToken ? `&accessToken=${accessToken}` : `&token=${token}`
              }`
            "
            alt=""
          />
          <div class="modal">
            <span @click="save('wechat')">另存为</span>
          </div>
        </div>
        <h3>微信扫一扫，分享打印机给好友</h3>
      </div>
      <div class="imgUrlBox" v-show="mode === 'qrcode'">
        <div class="imgUrl">
          <img
            id="qrcodeImg"
            :src="
              `https://dyapi.foxitcloud.cn/printEquipmentShare/getShareQrCode/${shareInfo &&
                shareInfo.shareCode}?appKey=${appkey}${
                accessToken ? `&accessToken=${accessToken}` : `&token=${token}`
              }`
            "
            alt=""
          />
          <div class="modal">
            <span @click="save('qrcode')">另存为</span>
          </div>
        </div>
        <h3>手机扫一扫，查看分享</h3>
      </div>
    </div>
    <div v-else v-loading="!shareInfo" style="height: 245px" />
  </el-dialog>
</template>

<script>
import Printer from "common/components/web/Printer.vue";
import { checkToken, checkIamToken } from "api/token";
import { APP_KEY, REQUEST_URL } from "const";
import store from "../../../../store";
import { mapState } from "vuex";
import { signIn } from "../../../../utils/utils";

export default {
  data() {
    return {
      title: "分享设备",
      visible: false,
      mode: "default",
      appkey: APP_KEY,
      token: localStorage.getItem("token")
        ? JSON.parse(localStorage.getItem("token")).token
        : null
    };
  },
  computed: {
    ...mapState("user", ["accessToken"])
  },
  props: {
    printer: {
      type: Object,
      default: null
    },
    shareInfo: {
      default: null,
      type: Object
    }
  },
  components: {
    Printer
  },
  methods: {
    handleClose() {
      this.visible = false;
      setTimeout(() => {
        this.mode = "default";
        this.$emit("clearShareInfo");
      }, 300);
    },
    copyUrl() {
      this.copy(this.shareInfo.shareLinks);
    },
    toggleMode(mode) {
      this.mode = mode;
    },
    /**
     * [signIn 登录]
     *
     * @return  {[type]}  [return description]
     */
    signIn() {
      signIn();
    },
    async save(type) {
      try {
        if (localStorage.getItem("loginType") === "iam") {
          await checkIamToken();
        } else {
          await checkToken();
        }
      } catch {
        this.$message.error("登录信息已过期");
        setTimeout(() => {
          return this.signIn();
        }, 1000);
      }
      let url;
      if (type === "qrcode") {
        url = `${REQUEST_URL}/printEquipmentShare/getShareQrCode/${
          this.shareInfo.shareCode
        }?appKey=${APP_KEY}&download=${true}`;
      } else {
        url = `${REQUEST_URL}/printEquipmentShare/getShareWxACode/${
          this.shareInfo.shareCode
        }?appKey=${APP_KEY}&download=${true}`;
      }
      if (localStorage.getItem("loginType") === "iam")
        url += `&accessToken=${store.state.user.accessToken}`;
      if (localStorage.getItem("token")) {
        url += `&token=${JSON.parse(localStorage.getItem("token")).token}`;
      }
      window.location.href = url;
    }
  }
};
</script>

<style lang="scss" scoped>
.shareDialog {
  ::v-deep {
    .el-dialog__title {
      font-size: 14px;
      line-height: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;
    }
    .el-dialog__body {
      padding: 5px 20px 40px;
    }
  }
}

.printer {
  padding-left: 12px;
  padding: 15px 12px;
  display: flex;
  align-items: center;
  background-color: #f7f7f7;
  border-radius: 4px;
  .printerImg {
    width: 37px;
  }
  .printInfo {
    display: flex;
    margin-left: 20px;
    flex-direction: column;
    width: 0;
    flex: auto;
    .printName {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
    .printDes {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 18px;
      letter-spacing: 0px;
      color: #999999;
    }
  }
}

.content {
  width: 100%;
  .title {
    margin-top: 3px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 44px;
    letter-spacing: 0px;
    color: #666666;
  }
  .shareBox {
    display: flex;
  }
  .shareInfo {
    border-radius: 2px 0 0 2px;
    flex: auto;
    background-color: #f7f7f7;
    border: solid 1px #d9d9d9;
    border-right: 0;
    padding: 10px 10px 0;
    width: 0;
    height: 68px;
    p {
      line-height: 14px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 23px;
      letter-spacing: 0px;
      color: #666666;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .copyBtn {
    width: 100px;
    height: 68px;
    background-color: $theme-color;
    border-radius: 0 2px 2px 0;
    cursor: pointer;
    text-align: center;
    line-height: 68px;
    color: white;
    flex-shrink: 0;
    &:hover {
      background-color: $theme-color-hover;
    }
  }
  .otherWay {
    display: flex;
    align-items: center;
    margin-top: 24px;
    span {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #666666;
      margin-right: 18px;
    }
    img {
      cursor: pointer;
      margin-right: 9px;
    }
  }
}

.imgUrlBox {
  width: 100%;
  .imgUrl {
    margin: 33px auto 18px;
    width: 144px;
    height: 144px;
    display: block;
    position: relative;
    img {
      width: 100%;
    }
    .modal {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      font-size: 14px;
      line-height: 100%;
      justify-content: center;
      align-items: center;
      color: white;
      top: 0;
      left: 0;
      background-color: #3333336e;
      span:active {
        color: #999999;
      }
    }
    &:hover {
      cursor: pointer;
      .modal {
        display: flex;
      }
    }
  }
  h3 {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 14px;
    letter-spacing: 0px;
    color: #333333;
    text-align: center;
  }
}
</style>
